module.exports = __webpack_public_path__ + "img/notice.390991ff.png";